import React, { useEffect } from 'react';
import { Form, Button, Row, Col, Select, Spin, DatePicker, Input } from 'antd';
import { ReactSVG } from 'react-svg';
import { DATE_BACKEND_FORMAT, DAY_FORMAT, JOB_ORDER_STATUSES } from '../../../constants';
import dayjs from 'dayjs';
import { doGetDrivers } from '../../../modules/driver/stores/thunk';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllDrivers } from '../../../modules/driver/stores/slice';
import { doGetClients } from '../../../modules/client/stores/thunk';
import { selectAllClients } from '../../../modules/client/stores/slice';

const JobOrdersFilter = ({ isFetching, query, onSubmit }) => {
  const [form] = Form.useForm();

  const drivers = useSelector((state) => selectAllDrivers(state));
  const clients = useSelector((state) => selectAllClients(state));

  const dispatch = useDispatch();

  const statusField = 'status';
  const statusValue = query[statusField];

  const deliveryDateFromField = 'deliveryDateFrom';
  const deliveryDateFromValue = query[deliveryDateFromField];

  const deliveryDateToField = 'deliveryDateTo';
  const deliveryDateToValue = query[deliveryDateToField];

  const clientField = 'clientId';
  const clientValue = query[clientField];

  const driverIdField = 'driverId';
  const driverIdValue = query[driverIdField];
  const jobOrderIdField = 'jobOrderId';
  const jobOrderIdValue = query[jobOrderIdField];
  const driverNameField = 'driverName';
  const driverNameValue = query[driverNameField];

  const filterOption = (input, option = null) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  useEffect(() => {
    form.setFieldsValue(initialValues());
  }, [query]);

  useEffect(() => {
    dispatch(doGetDrivers({ page: 1, take: 1000 }));
    dispatch(doGetClients({ page: 1, take: 1000 }));
  }, []);

  console.log({ drivers, clients });
  const initialValues = () => {
    const values = {};
    values[statusField] = statusValue || '';
    values['deliveryDate'] = [
      deliveryDateFromValue ? dayjs(deliveryDateFromValue, DATE_BACKEND_FORMAT) : null,
      deliveryDateToValue ? dayjs(deliveryDateToValue, DATE_BACKEND_FORMAT) : null,
    ];
    values[clientField] = clientValue ? Number(clientValue) : '';
    values[driverIdField] = driverIdValue ? Number(driverIdValue) : '';
    values[jobOrderIdField] = jobOrderIdValue || '';
    values[driverNameField] = driverNameValue || '';
    return values;
  };

  const handleSubmit = (values) => {
    const params = {};
    const deliveryDate = values['deliveryDate'] || [];
    params[statusField] = values[statusField] || undefined;
    params[deliveryDateFromField] = deliveryDate[0] ? deliveryDate[0].format(DATE_BACKEND_FORMAT) : undefined;
    params[deliveryDateToField] = deliveryDate[1] ? deliveryDate[1].format(DATE_BACKEND_FORMAT) : undefined;
    params[clientField] = values[clientField] || '';
    params[driverIdField] = values[driverIdField] || '';
    params[jobOrderIdField] = values[jobOrderIdField] || '';
    params[driverNameField] = values[driverNameField] || '';
    onSubmit({ ...query, ...params, current: 1 }, true);
  };

  const handleResetButton = () => {
    onSubmit({}, true);
    form.resetFields();
  };

  return (
    <Spin spinning={isFetching}>
      <div className="CommonFilter OrdersFilter">
        <Form
          form={form}
          onFinish={handleSubmit}
          initialValues={initialValues()}
          className="FilterForm OrdersFilterForm"
          layout="vertical"
        >
          <div className="FilterFormHeader">
            <h4>Filter</h4>
            <div className="actions">
              <Button size="small" type="text" onClick={handleResetButton}>
                Clear
                <ReactSVG className="icon" src="/icons/clear_all.svg" />
              </Button>
              <Button className="apply" size="small" type="link" htmlType="submit">
                Apply
                <ReactSVG className="icon" src="/icons/done.svg" />
              </Button>
            </div>
          </div>
          <div className="FilterFormContent">
            <Row gutter={15}>
              <Col xs={{ span: 24 }} md={{ span: 8 }}>
                <Form.Item label="Status" name={statusField}>
                  <Select
                    className="select-small"
                    options={[
                      { label: 'ALL', value: '' },
                      ...Object.keys(JOB_ORDER_STATUSES).map((key) => ({ label: JOB_ORDER_STATUSES[key], value: key })),
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 8 }}>
                <Form.Item label="Delivery Date" name="deliveryDate">
                  <DatePicker.RangePicker format={DAY_FORMAT} placeholder={['From', 'To']} allowEmpty={[true, true]} />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 8 }}>
                <Form.Item label="Job Order ID" name={jobOrderIdField}>
                  <Input placeholder="e.g. PADE3JWEA" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 8 }}>
                <Form.Item label="Driver Name" name={driverNameField}>
                  <Input placeholder="e.g. Jake Kennedy" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 8 }}>
                <Form.Item label="Client" name={clientField}>
                  <Select
                    className="select-small"
                    showSearch
                    filterOption={filterOption}
                    options={[
                      { label: 'ALL', value: '' },
                      ...clients.map((client) => ({ label: client.name, value: client.id })),
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 8 }}>
                <Form.Item label="Driver" name={driverIdField}>
                  <Select
                    className="select-small"
                    showSearch
                    filterOption={filterOption}
                    options={[
                      { label: 'ALL', value: '' },
                      ...drivers.map((driver) => ({
                        label: `${driver?.user?.firstName} ${driver?.user?.lastName}`,
                        value: driver.id,
                      })),
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default JobOrdersFilter;
